module.exports = __webpack_public_path__ + "img/tree-05-b-trunk.b09fd1f6.png";